<template>
  <el-form
    :model="form"
    :rules="rules"
    v-loading="loading"
    ref="form"
  >
    <el-card style="width: 800px;">
      <div
        slot="header"
        style="font-size:20px;color: #505458;margin: 0px 0px 0px 0px;"
      >
        <i class="el-icon-s-grid"></i>
        <span>工程分部</span>
      </div>
      <el-form-item
        prop="name"
        style="width: 500px;margin: 0px auto;"
      >
        <el-input
          type="text"
          v-model="form.name"
          autocomplete="off"
          placeholder="模板名称"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="date"
        style="width: 500px;margin: 15px auto;"
      >
        <el-date-picker
          v-model="form.date"
          type="month"
          placeholder="选择时间"
          :clearable="false"
          style="width: 500px;"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        :key="index"
        style="margin: 20px auto 0px auto;"
        v-for='(item, index) of checkedData.projectItemTreeData'>
          <tree-menu-project-item
            ref="projectItemTreeMenu"
            :type='treeMenuProjectItemType'
            :item='item'
            :depth='0'
            :majorMaterialList='majorMaterialList'
          >
          </tree-menu-project-item>
      </el-form-item>
    </el-card>
    <el-card style="width: 800px; margin-top: 30px;">
      <div
        slot="header"
        style="font-size:20px;color: #505458;margin: 0px 0px 0px 0px;"
      >
        <i class="el-icon-s-marketing"></i>
        <span>主要材料单方用量指标</span>
      </div>
      <el-form-item
        style="margin:0px auto;">
        <el-checkbox-group v-model="checkedData.majorMaterialUsageCheckList">
          <el-checkbox
          v-for="majorMaterial in checkedData.majorMaterialUsageTreeData"
          :label="majorMaterial.id"
          :key="majorMaterial.id"
          :checked="true"
            >{{majorMaterial.name}}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

    </el-card>
    <el-form-item style="margin:30px auto;" v-if="type == 'add'">
      <el-button
        type="primary"
        style="width: 100%;border: none"
        v-on:click="save"
        >保存</el-button
      >
    </el-form-item>
    <el-form-item style="margin:30px auto;" v-if="type == 'edit'">
      <el-button
        type="primary"
        style="width: 100%;border: none"
        v-on:click="save"
        >更新</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import TreeMenuProjectItem from './TreeMenuProjectItem.vue'
export default {
  name: 'AddProjectTemplate',
  components: {
    TreeMenuProjectItem
  },

  props: {
    type: {
      type: String,
      default: ''
    },
    rules: {},
    checkedData: {
      projectItemTreeData: [],
      majorMaterialUsageCheckList: [],
      majorMaterialUsageTreeData: []
    },
    form: {
      id: 0,
      name: '',
      date: null,
      projectItems: '',
      majorMaterialsUsage: ''
    }
  },

  data () {
    return {
      loading: false,
      treeMenuProjectItemType: 'template',
      majorMaterialList: [],
      projectItemCheckList: []
    }
  },

  methods: {
    getCheckedProjectItems (item) {
      var checkedItemList = []
      if (item.item && item.item.checked) {
        // if (!item.item.majorMaterials || item.item.majorMaterials.length === 0) {
        //   _this.$message.error({ message: item.item.name + '未选择任何主材' })
        //   return false
        // }
        if (item.item.cost === undefined) {
          this.$message.error({ message: item.item.name + '单方造价未填写' })
          return false
        }
        var majorMaterialList = []
        if (item.item.majorMaterials && item.item.majorMaterials.length > 0) {
          var percent = 0
          for (var j = 0; j < item.item.majorMaterials.length; j++) {
            if (!item.item.majorMaterials[j].id) {
              this.$message.error({ message: item.item.name + '有主材未选择' })
              // return false
            } else if (!item.item.majorMaterials[j].percent || item.item.majorMaterials[j].percent === '') {
              this.$message.error({ message: item.item.name + '未设定主材百分比' })
              return false
            }
            percent += Number(item.item.majorMaterials[j].percent)
          }
          if (percent > 100) {
            this.$message.error({ message: item.item.name + '主材百分比总和不能大于100' })
            return false
          }
          for (var k = 0; k < item.item.majorMaterials.length; k++) {
            majorMaterialList.push(item.item.majorMaterials[k].id + '-' + item.item.majorMaterials[k].percent)
          }
        }
        checkedItemList.push(item.item.id + ':' + item.item.cost + ':' + majorMaterialList.join('|'))
      }
      if (item.$children) {
        for (var i = 0; i < item.$children.length; i++) {
          var projectItems = this.getCheckedProjectItems(item.$children[i])
          if (projectItems === false) {
            return false
          }
          checkedItemList = checkedItemList.concat(projectItems)
        }
      }
      return checkedItemList
    },

    save () {
      var _this = this

      this.$data.projectItemCheckList = []
      for (var i = 0; i < this.$refs.projectItemTreeMenu.length; i++) {
        var projectItems = this.getCheckedProjectItems(this.$refs.projectItemTreeMenu[i])
        if (projectItems === false) {
          return
        }
        this.$data.projectItemCheckList = this.$data.projectItemCheckList.concat(projectItems)
      }

      if (this.$data.projectItemCheckList.length === 0) {
        this.$message.error({ message: '未选择任何工程分部' })
        return
      }

      if (this.$props.checkedData.majorMaterialUsageCheckList.length === 0) {
        this.$message.error({ message: '未选择任何主要材料指标' })
        return
      }

      this.$refs.form.validate(valid => {
        if (valid) {
          _this.form.projectItems = _this.$data.projectItemCheckList.join(',')
          _this.form.majorMaterialsUsage = _this.$props.checkedData.majorMaterialUsageCheckList.join(',')
          _this.$data.loading = true
          _this.postRequest('/project_templates/' + _this.type, _this.form)
            .then(resp => {
              _this.$data.loading = false
              if (resp && resp.code === 200) {
                _this.$message.success({ message: _this.type === 'add' ? '保存成功' : '更新成功' })
                if (_this.type === 'add') {
                  _this.$router.replace('/project_templates')
                }
              }
            })
        } else {
          _this.$message.error({ message: '请完整填写表单' })
        }
      })
    }
  },

  mounted () {
    var self = this
    var dataLoadedCount = 0
    var loadComplete = function () {
      dataLoadedCount++
      if (dataLoadedCount === 1) {
      }
    }

    this.getRequest('/major_materials')
      .then(resp => {
        if (resp && resp.result) {
          self.$data.majorMaterialList = resp.result
          loadComplete()
        }
      })
  }
}
</script>

<style scoped>

</style>
